import React, { useState, useContext } from "react"
import { Link, useHistory } from "react-router-dom"
import { SmartDateFormat } from "../../util/dates"
import CommentSection from "../comments/CommentSection"
import { TextAsImage } from "./TextAsImage"
import { PostListItemExpandedStyles } from "./constants"
import { ShareUrlButton } from "../ShareUrlButton"
import { ExternalPhotoSrcHeader } from "./ExternalPhotoSrcHeader"
import { ShowHideButton } from "../shared/Button"
import { ReactionBlock } from "./ReactionBlock"
import RelatedPosts from "../RelatedPosts"
import ImageVideoAlbumPlayer from "@components/ImageVideoAlbumPlayer"
import clsx from "clsx"
import FreeTextFormat from "../shared/FreeTextFormat"
import styles from "./styles.module.css"
import PremiereHeader from "./PremiereHeader"
import HeadlinePostForm from "../HeadlinePostForm"
import { UserContext } from "../HomeApp"
import EditManageHeader from "../EditManageHeader"
import { root_path } from "../../routes"

export const HeadlineListItemExpanded = ({
  headline,
  updateStatus,
  adminMode = false,
  isPostPage = false,
}) => {
  const metaClass = isPostPage ? "col-span-12 pt-2" : PostListItemExpandedStyles.metaDiv
  const commentsClass = isPostPage ? "col-span-12 pt-4" : PostListItemExpandedStyles.commentsDiv
  const [postStatus, setPostStatus] = useState(headline.status)
  const [currentHeadline, setCurrentHeadline] = useState(headline)
  const [showEditForm, setShowEditForm] = useState(false)
  const [deleted, setDeleted] = useState(false)
  const { user } = useContext(UserContext)
  const isOwner = user && user.band && user.band.id === headline.band_id
  const history = useHistory()

  const handleDeleted = () => {
    if (isPostPage) {
      history.push(root_path())
    } else {
      setDeleted(true)
    }
  }

  if (deleted) return null

  return showEditForm ? (
    <HeadlinePostForm
      bandId={user.band_id}
      setShowForm={setShowEditForm}
      post={headline}
      setNewPost={setCurrentHeadline}
      onDeleted={handleDeleted}
    />
  ) : (
    <div className="grid grid-cols-12 py-1">
      <PremiereHeader post={headline} size="large" />
      {headline.attached_media ? (
        <ImageVideoAlbumPlayer
          attachedMedia={headline.attached_media}
          expanded={true}
        />
      ) : headline.external_photo_src ? (
        <ExternalPhotoSrcHeader
          externalPhotoSrc={headline.external_photo_src}
          alt={headline.title_cleaned || headline.title}
          contentDivClassName={PostListItemExpandedStyles.contentDiv}
          showFullImage={true}
        />
      ) : (
        <TextAsImage
          text={headline.title_cleaned || headline.title}
          expanded={true}
        />
      )}
      <div className={metaClass}>
        <EditManageHeader
          isOwner={isOwner}
          post={headline}
          setShowEditForm={setShowEditForm}
        />
        <div className="flex items-start justify-between">
          <div className="flex-grow">
            <h2
              className={clsx(
                PostListItemExpandedStyles.header,
                headline.title.length > 100
                  ? PostListItemExpandedStyles.headerLong
                  : PostListItemExpandedStyles.headerShort,
                headline.is_bn_premiere && styles.premiereTitle,
                headline.status === "trashed" && "line-through",
              )}
            >
              <FreeTextFormat
                text={
                  headline.title
                    ? headline.title_cleaned || headline.title
                    : `New Headline from ${headline.band_name}`
                }
                expandable={false}
                expanded={false}
                linkify={true}
              />
            </h2>
          </div>
          <ShareUrlButton
            nadaUrl={headline.nada_url}
            renderMode="button"
            className="ml-0"
          />
        </div>
        <Link
          className={PostListItemExpandedStyles.bandName}
          to={headline.local_path}
        >
          {headline.band_name}
        </Link>
        <h3 className={PostListItemExpandedStyles.postDate}>
          Posted:&nbsp;
          {SmartDateFormat({
            dateStr: headline.published_at,
            includeTime: false,
          })}
        </h3>

        <div className="mt-4">
          <ReactionBlock
          contentType="Post"
          contentId={headline.id}
          postId={headline.id}
        />
        </div>

        <div className="text-sm text-gray-800 mt-2 mb-4">
          <FreeTextFormat
            text={
              headline.original_text
                ? headline.original_text
                : `New Headline from ${headline.band_name}`
            }
            expandable={false}
            expanded={true}
            linkify={true}
          />
        </div>

      </div>
      <div className={commentsClass}>
        {adminMode && (
          <ShowHideButton
            updateStatus={updateStatus}
            postStatus={postStatus}
            setPostStatus={setPostStatus}
          />
        )}
        <RelatedPosts postId={headline.id} className="mb-4" />
        
        <CommentSection
          postId={headline.id}
          headerText="The Peanut Gallery Says:"
          className="mb-4"
        />
      </div>
    </div>
    )
}
